// src/components/Footer.tsx
const Footer = () => {
  return (
    <footer className="container mx-auto px-6 py-8 text-center text-gray-600 bg-gray-100">
      <p>Built for Google Workspace teams by Google Workspace enthusiasts</p>
      <p className="mt-2 text-sm">© {new Date().getFullYear()} SignoBox. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
